export default class SaveGameEvent {
    constructor(type, data) {
        this.type = type;
        this.data = data;
    }
}

SaveGameEvent.SAVE_GAME = "SaveGameEvent.SAVE_GAME";
SaveGameEvent.LOAD_GAME = "SaveGameEvent.LOAD_GAME";
SaveGameEvent.GAME_LOADED = "SaveGameEvent.GAME_LOADED";
SaveGameEvent.GAME_SAVED = "SaveGameEvent.GAME_SAVED";